import DocsConfig from '@tencent/docs-config';
const appConfigInstance = DocsConfig.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
let p = (!!npmConfig && npmConfig.CDN_ORIGIN) || 'https://docs.gtimg.com/docs-design-resources';
p = p + '/cooperation/ai/template/template_ppt_techno_ray_blue/'
export function getTemplateThumbnail1() { return p+'template_thumbnail_1-1c217abe06.png'; };
export function getTemplateThumbnail10() { return p+'template_thumbnail_10-65ed76f0e6.png'; };
export function getTemplateThumbnail2() { return p+'template_thumbnail_2-44aa50a49c.png'; };
export function getTemplateThumbnail3() { return p+'template_thumbnail_3-48afd1462a.png'; };
export function getTemplateThumbnail4() { return p+'template_thumbnail_4-a8fbba54e2.png'; };
export function getTemplateThumbnail5() { return p+'template_thumbnail_5-dfd0966cb8.png'; };
export function getTemplateThumbnail6() { return p+'template_thumbnail_6-2a604203e7.png'; };
export function getTemplateThumbnail7() { return p+'template_thumbnail_7-df9ae10690.png'; };
export function getTemplateThumbnail8() { return p+'template_thumbnail_8-29f0b60f48.png'; };
export function getTemplateThumbnail9() { return p+'template_thumbnail_9-5f04308cd4.png'; };
